// @ts-expect-error not typed
import LanguageSelect from 'ui-addon-i18n/components/LanguageSelect';
import useContentSupportedLanguages from '../../hooks/useFetchContentSupportedLanguages';
// import { UISelectProps } from 'UIComponents/input/UISelect';

// LanguageSelect has not been migrated to use Trellis Select (it's also not typed)
// so falling back to use any for now. According to this thread (https://hubspot.slack.com/archives/C1WG3L3J6/p1740082882128159?thread_ts=1740082193.338379&cid=C1WG3L3J6)
// it's not on their radar to migrate it anytime soon.
// type Props = UISelectProps & {
//   optionsFilter?: Function;
//   enableSelectAll?: boolean;
// };
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContentSupportedLanguageSelect(props) {
  const {
    contentSupportedLanguages,
    isLoading
  } = useContentSupportedLanguages();
  return /*#__PURE__*/_jsx(LanguageSelect, Object.assign({
    "aria-label": "Select a language",
    error: !isLoading && undefined,
    isLoading: isLoading
  }, props, {
    validLanguages: contentSupportedLanguages
  }));
}